import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import Helmet from 'react-helmet';

import ContactForm from '../components/ContactForm.jsx'
import { getFirstImage } from '../helpers/helperFunctions.js';


const Works = () => {
	const [headerHeight, setHeaderHeight] = useState(0);
	const [loading, setLoading] = useState(false)
	const [article, setArticle] = useState(null)
	const [articleRecords, setArticleRecords] = useState([])
	const [articleVideo, setArticleVideo] = useState(null)
	const [otherVideos, setOtherVideos] = useState([])
	const [articleImages, setArticleImages] = useState([])
	const [mixedImagesAndOtherVideos, setMixedImagesAndOtherVideos] = useState([])
	const params = useParams();
	const articleUrl = process.env.REACT_APP_API_ARTICLE_URL;

	useEffect(() => {

		//console.log(articleUrl);
		if (!params.workSlug) return;

		const fetchData = async () => {
			axios.get(`${articleUrl}${params.workSlug}?IncludeRelatedArticles=true`)
				.then(res => {
					const response = res.data;
					setArticle(response);
					/*console.log("ArticleDetail", response);*/
				})
		}

		fetchData();
	}, []);


	const updateHeaderHeight = () => {
		const header = document.querySelector('header');
		setHeaderHeight(header.offsetHeight + 64);
	};

	useEffect(() => {
		updateHeaderHeight();
		window.addEventListener('resize', updateHeaderHeight);

		return () => {
			window.removeEventListener('resize', updateHeaderHeight);
		};
	}, []);

	useEffect(() => {
		if (!article) return;
		let currentRecs = [];
		article.notes?.split(/\n/).map((item) => {
			const matches = item.match(/\[element-(.*?):(.*?)\]/);
			if (matches) {
				const element = matches[1];  // Es. 'follower'
				const value = matches[2];    // Es. '200k'
				currentRecs.push({ label: element, value: value });
			}
		})
		setArticleRecords(currentRecs)
	}, [article])

	useEffect(() => {
		if (!article) return;
		let video = article.media?.find((el) => {
			return el.isVideo;
		});
		setArticleVideo(video);
		let otherVideos = article.media?.filter((el) => {
			return el.isVideo && el.url != video.url;
		});
		setOtherVideos(otherVideos);
	}, [article])

	useEffect(() => {
		if (!article) return;
		let images = article.media?.filter((el) => {
			return el.isImage;
		});
		// Skip the first image bc used next to the title  
		setArticleImages(images.slice(1, images.length));
	}, [article])

	useEffect(() => {
		console.log(articleImages.length, otherVideos.length)
		if (articleImages.length > 0 && otherVideos.length > 0) {
			setMixedImagesAndOtherVideos([...articleImages, ...otherVideos]);
		} else {
			setMixedImagesAndOtherVideos([]);
			return;
		}

	}, [articleImages, otherVideos]);

	useEffect(() => {
		if (!articleImages.length) return;
		imagesLoaded(document.querySelector('.grid'), function (instance) {
			/*console.log('all images are loaded');*/
			var elem = document.querySelector('.grid');
			var msnry = new Masonry(elem, {
				itemSelector: '.grid-item',
				columnWidth: '.grid-sizer',
				percentPosition: true,
				gutter: 30,
				//columnWidth: 200
			});
		});

	}, [articleImages])

	const renderVideo = (video, masonry = false) => {
		if (!video) return;

		const media = video.url;
		const mediaIsYoutube = media.includes("youtube");
		const mediaWrongLink = media.includes("youtu.be");
		const mediaIsVimeo = media.includes("vimeo");

		if (mediaWrongLink) {
			return (
				<div className={`h-100 w-100 border border-3 border-danger d-flex align-items-center justify-content-center p-4 p-lg-5 ${masonry ? '' : 'container-lg mt-5 mb-7 bg-dark px-lg-10 py-lg-6'}`} style={!masonry ? { minHeight: 500 } : {}}>
					<h3 className="text-center lh-base">
						Il link di youtube non inserito correttamente. Utilizzare la funzione di condivisione 'incorpora'' e copiare solamente il link generato
					</h3>
				</div>
			);
		}

		if (mediaIsYoutube) {
			const noCookieUrl = media.replace("youtube", "youtube-nocookie");
			return (
				<div className={masonry ? "" : "container-lg mt-5 mb-7 bg-dark px-lg-10 py-lg-6"}>
					<div className="row">
						<div className="col-12">
							<iframe
								id="player"
								type="text/html"
								width="100%"
								height={masonry ? "100%" : "500px"}
								style={masonry ? { minHeight: 300 } : {}}
								className={masonry ? "w-100 h-100 object-fit-cover" : "object-fit-contain"}
								src={noCookieUrl}
								allow="accelerometer; clipboard-write; encrypted-media; gyroscope;"
								allowFullScreen
							></iframe>
						</div>
					</div>
				</div>
			);
		}

		if (mediaIsVimeo) {
			return (
				<div className={masonry ? "" : "container-lg mt-5 mb-7 bg-dark px-lg-10 py-lg-6"}>
					<div className="row">
						<div className="col-12">
							<iframe
								id="player"
								type="text/html"
								width="100%"
								height={masonry ? "100%" : "500px"}
								style={masonry ? { minHeight: 300 } : {}}
								className={masonry ? "w-100 h-100 object-fit-cover" : "object-fit-contain"}
								src={media + "?title=0&byline=0&autoplay=1&loop=1&background=1"}
								allow="accelerometer; clipboard-write; encrypted-media; gyroscope;"
								allowFullScreen
							></iframe>
						</div>
					</div>
				</div>
			)
		}

		return (
			<div className={masonry ? "" : "container-lg mt-5 mb-7 bg-dark px-lg-10 py-lg-6"}>
				<div className="row">
					<div className="col-12">
						<video
							controls
							className={masonry ? "w-100 h-100 object-fit-cover" : "object-fit-contain"}
							autoPlay={!masonry}
							muted={true}
							preload="none"
							width="100%"
							style={masonry ? {} : { maxHeight: 500 }}
						>
							<source src={media} type="video/mp4" />
							Your browser does not support the video tag.
						</video>
					</div>
				</div>
			</div>
		);
	};

	const removeHtml = (html) => {
		const doc = new DOMParser().parseFromString(html, 'text/html');
		return doc.body.textContent || "";
	}


	return (
		<>
			{article && (
				<Helmet>
					<title>{`Epoca - ${article.title}`}</title>
					{article.media && article.media.length > 0 ? (
						<meta name="description" content={removeHtml(article.media[0].description)} />
					) : (
						<meta name="description" content="Epoca offre consulenza e advisoring nel settore del marketing e della comunicazione d'impresa." />
					)}
					<meta property="og:url" content={``} />
					<meta property="og:type" content="article" />
					<meta property="og:title" content={`Epoca - ${article.title}`} /> 
					<meta property="og:site_name" content="epocagroup.it" />
					{article.media && article.media.length > 0 ? (
						<meta property="og:description" content={removeHtml(article.media[0].description)} />
					) : (
						<meta property="og:description" content={`Epoca offre consulenza e advisoring nel settore del marketing e della comunicazione d'impresa.`} />
					)}
				</Helmet>
			)}
			{article && (
				<div className='page-content' style={{ paddingTop: headerHeight }}>
					<div className='container-lg'>
						<div className='row'>
							<div className={article.media.length > 0 ? "col-lg-6" : "col"}>
								<h1 className='page-title m-0'>{article.title}</h1>
								{article.author && (
									<div className='serif fw-semibold fs-6 lh-sm'>{article.author}</div>
								)}
							</div>
							{article.media.length > 0 && (
								<div className='col-lg-6 text-center text-lg-end'>
									<img src={article.media[0].urlLarge || article.title + ": immagine correlata"} className='mt-5 mt-lg-8 img-fluid' />
								</div>
							)}
						</div>
						{article.media.length > 0 && (
							<div className='row my-5'>
								<div className='col ps-lg-6 pe-lg-10 fs-5 fw-semibold serif' dangerouslySetInnerHTML={{ __html: article.media[0].description }}></div>
							</div>
						)}
					</div>

					{renderVideo(articleVideo, false)}

					{article.description && (
						<div className='container-lg my-5'>
							<div className='row'>
								<div className='col'>
									<h3 className='border-bottom fs-2 fw-bold pb-2 mb-3 text-uppercase'>BACKGROUND</h3>
									<div className='serif fw-500 fs-5' dangerouslySetInnerHTML={{ __html: article.description }}></div>
								</div>
							</div>
						</div>
					)}

					{mixedImagesAndOtherVideos.length <= 0 ? (
						<>
							{articleImages.length > 0 ? (
								<div className='container-lg only-img mb-7'>
									<div className='row'>
										<div className='col'>
											<div className='grid' data-masonry='{"itemSelector": ".grid-item"}'>
												<div className='grid-sizer'></div>
												{articleImages.map((img, index) =>
													<div className={`grid-item pb-0 ${index == 0 ? "grid-itemx2" : ""}`} key={index}>
														<img src={img.urlLarge || article.title + ": immagine correlata"}  />
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
							) : otherVideos.length > 0 && (
								<div className='container-lg only-vid mb-7'>
									<div className='row'>
										<div className='col'>
											<div className='grid' data-masonry='{"itemSelector": ".grid-item"}'>
												<div className='grid-sizer'></div>
												{otherVideos.map((video, index) =>
													<div className={`grid-item pb-0 ${index == 0 ? "grid-itemx2" : ""}`} key={index}>
														{renderVideo(articleVideo, true)}
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
							)}
						</>
					) : (
						<div className='container-lg mixed mb-7'>
							<div className='row'>
								<div className='col'>
									<div className='grid' data-masonry='{"itemSelector": ".grid-item"}'>
										<div className='grid-sizer'></div>
										{mixedImagesAndOtherVideos.map((item, index) =>
											<div className={`grid-item pb-0 ${index == 0 ? "grid-itemx2" : ""}`} key={index}>
												{item.isImage ? (
													<img src={item.urlLarge || article.title + ": immagine correlata"} />
												) : renderVideo(item, true)
												}
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					)}


					{article.text && (
						<div className='container-lg my-5'>
							<div className='row'>
								<div className='col'>
									<div className='serif fw-500 fs-5' dangerouslySetInnerHTML={{ __html: article.text }}></div>
								</div>
							</div>
						</div>
					)}

					{articleRecords.length > 0 && (
						<section className='bg-light'>
							<div className='container-lg'>
								<div className='row'>
									<div className='col'>
										<div className='d-flex flex-wrap justify-content-between work-records-container py-4 py-lg-8 px-lg-8'>
											{articleRecords.map((rec, index) =>
												<div key={index} className='py-3 border-top border-dark mt-4 mt-lg-0 w-100 w-md-auto'>
													<div className='fs-3 fw-bold work-record-value' style={{ lineHeight: '2.1rem' }}>{rec.value}</div>
													<div className='fs-5 fw-semibold text-uppercase' style={{ lineHeight: '1rem' }}>{rec.label}</div>
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
						</section>
					)}

					{/*{articleImages.length > 2 && (
						<div className='container-lg mt-8'>
							<div className='row my-5 align-items-center px-lg-7'>
								<div className='col-md-6 ps-lg-4 pe-lg-4 mb-4 mb-md-0'>
									<img src={articleImages.at(-1).urlLarge  || article.title + ": immagine correlata"} className='img-fluid' />
								</div>
								<div className='col-md-6 ps-lg-4 pe-lg-4 fs-5 fw-500 serif'>
									{articleImages.at(-1).description}
								</div>
							</div>
						</div>
					)}*/}

					<section className='bg-dark text-white mb-8 py-7'>
						<div className='container-lg'>
							<div className='row align-items-end'>
								{article.relatedArticles?.length > 0 && (
									<div className='col-lg-6 text-center text-lg-start'>
										<h4 className='text-uppercase mb-3 fs-4 fw-bold'>CASE <br className="d-none d-md-block" />SUGGERITE</h4>
										<div className='d-flex flex-wrap justify-content-center justify-content-lg-start related-works-container pe-xl-5'>
											{article.relatedArticles.slice(0, 2).map((related, index) =>
												<a className='related-work image-bg-item' href={`/works/${related.friendlyName.split('/').pop()}`} key={index}
													style={{ "--image-url": `url('${getFirstImage(related, "urlFullHD")}')` }}>
													<h5 className='m-0 fs-4 text-white text-uppercase text-start' style={{ letterSpacing: '-2px' }}>{related.title}</h5>
												</a>
											)}
										</div>
									</div>
								)}
								<div className='col-lg-6 mt-7'>
									<div className='contact-form-container'>
										<h3 className='text-uppercase text-white fs-1 fw-lighter mb-4' style={{ letterSpacing: '-1px' }}>Contact</h3>
										<ContactForm />
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			)}
		</>
	);
}

export default Works;